'use client'
import BlogPostPreview from "@/app/components/pages/blog/BlogPostPreview";
import BlogPostFilter from "@/app/components/pages/blog/BlogPostFilter";
import React from "react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import Pagination from "@/app/components/common/Pagination";
import styles from "@/app/styles/components/pages/blog/blog-posts.module.scss";
import {useRouter} from "next/navigation";

const BlogPosts = ({pageData, route}) => {
    const router = useRouter()
    const [page, setPage] = useState(1);
    const [activeCategory, setActiveCategory] = useState(null);

    const onPageChange = (page) => {
        setPage(page);

        let params = {
            page: page
        }

        if(activeCategory) {
            params = {
                ...params,
                categories: activeCategory.id
            }
        }

        fetchData(params)
    };

    const onCategoryChange = (category) => {
        setActiveCategory(category);
        setPage(1);

        let params = {
            page: page
        }

        if(category) {
            params = {
                ...params,
                categories: category.id
            }
        }

        fetchData(params)
    };

    const fetchData = (params) => {
        const urlParams = new URLSearchParams(params).toString();
        router.push(route + '?' + urlParams, { shallow: false });
    }

    const renderPostList = (posts, categories) => {

        return posts.map((post) => (
            <div className={styles.onePostContainer} key={'post-' + post.id}>
                <BlogPostPreview post={post} categories={categories} />
            </div>
        ));
    };

    return <>
        <div className={styles.mainContainer}>
            <div className="container">
                <div className={styles.buttonsContainer}>
                    <button
                        className={`${styles.btnAllCategories} ${activeCategory ? '' : styles.active}`}
                        onClick={() => {
                            onCategoryChange(null);
                        }}>
                        <FormattedMessage id={'components.pages.blog.blogPosts.allCategories'}/>
                    </button>
                    <BlogPostFilter
                        categories={pageData.categories}
                        onChange={onCategoryChange}
                    />
                </div>
                <div className={styles.allPostsContainer}>
                    {renderPostList(pageData.data, pageData.categories)}
                </div>
                <Pagination
                    items={pageData.total}
                    currentPage={page}
                    pageSize={9}
                    onPageChange={onPageChange}
                />
            </div>
        </div>
    </>
};

export default BlogPosts;


